import { LABELS } from '@/constants/common/message.constants'

import { type CustomerEntity } from '../../aspida/@types'

/**
 * 税計算方式
 */
export type TaxCalculationType = CustomerEntity['taxCalculationType']

export const TAX_CALCULATION_TYPE = {
  /** 一括計算 */
  BULK_CALCULATION: 'BULK_CALCULATION',
  /** 個別計算 */
  INDIVIDUAL_CALCULATION: 'INDIVIDUAL_CALCULATION'
} as const satisfies Record<TaxCalculationType, TaxCalculationType>

export const TAX_CALCULATION_TYPE_LABEL = {
  [TAX_CALCULATION_TYPE.BULK_CALCULATION]: LABELS.BULK_CALCULATION, // 一括計算
  [TAX_CALCULATION_TYPE.INDIVIDUAL_CALCULATION]: LABELS.INDIVIDUAL_CALCULATION // 個別計算
} as const satisfies Record<TaxCalculationType, string>

export function getTaxCalculationTypeLabel(type: TaxCalculationType): string {
  return TAX_CALCULATION_TYPE_LABEL[type]
}
